import React, { useState, useEffect } from "react";
import Select from "react-select";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import { userInputs } from "../../formSource";
import { useNavigate } from "react-router-dom";
import { serverUrl } from "../../temp";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";

const theme = createTheme({
  palette: {
    primary: {
      main: "#7451f8",
    },
    secondary: {
      main: "#6c757d",
    },
  },
});

const UserNew = ({ title }) => {
  const navigate = useNavigate();
  const [inputValues, setInputValues] = useState({});
  const [options, setOptions] = useState([]);
  const [filteredOptions, setFilteredOptions] = useState([]);
  const [selectedRoles, setSelectedRoles] = useState([]);
  const token = localStorage.getItem("token");
  const slug = localStorage.getItem("slugs");
  const UserNewSlug = "User-New";
  const Checking = slug.includes(UserNewSlug);

  const redirectToLogin = () => {
    alert("Please Login first, then you can access this page...");
    window.location.href = "/";
  };

  useEffect(() => {
    fetchRoles();
  }, []);

  const fetchRoles = async () => {
    try {
      const response = await fetch(`${serverUrl}/role_ids`);
      if (!response.ok) {
        throw new Error("Failed to fetch data from the API");
      }
      const data = await response.json();
      const rolesList = data.data.map(({ id, name }) => ({
        value: id,
        label: name,
      }));
      setOptions(rolesList);
      setFilteredOptions(rolesList);
    } catch (error) {
      console.error("Error fetching roles:", error);
      toast.error("Failed to fetch role data");
    }
  };

  const handleInputChange = (e) => {
    setInputValues({
      ...inputValues,
      [e.target.name]: e.target.value,
    });
  };

  const handleRoleSelectChange = (selectedOptions) => {
    setSelectedRoles(selectedOptions);
    const selectedIds = selectedOptions.map((opt) => opt.value);
    const updatedFiltered = options.filter(
      (opt) => !selectedIds.includes(opt.value)
    );
    setFilteredOptions(updatedFiltered);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const roleValues = selectedRoles.map((option) => option.value);

    const formData = new FormData();
    formData.append("center_id", localStorage.getItem("center_id"));
    formData.append("name", inputValues.name);
    formData.append("email", inputValues.email);
    formData.append("phone_no", inputValues.phone_no);
    formData.append("password", inputValues.password);
    formData.append("role_id", [roleValues]);

    try {
      const response = await fetch(`${serverUrl}/add_user`, {
        method: "POST",
        body: formData,
      });

      const data = await response.json();

      if (data.code >= 400) {
        if (typeof data.message === "object") {
          Object.entries(data.message).forEach(([field, errors]) => {
            errors.forEach((errMsg) => {
              toast.error(`${field}: ${errMsg}`);
            });
          });
        } else {
          toast.error(data.message || "Something went wrong.");
        }
        setInputValues({});
        setSelectedRoles([]);
        setFilteredOptions(options);
      } else {
        toast.success("User added successfully!");
        setInputValues({});
        setSelectedRoles([]);
        setFilteredOptions(options);
        setTimeout(() => {
          navigate("/user");
        }, 1000);
      }
    } catch (error) {
      console.error(error);
      toast.error("Network error. Please try again.");
      setInputValues({});
      setSelectedRoles([]);
      setFilteredOptions(options);
    }
  };

  return (
    <ThemeProvider theme={theme}>
      {Checking ? (
        <>
          {!token && redirectToLogin()}
          {token && (
            <div className="new">
              <Sidebar />
              <div className="newContainer">
                <Navbar />
                <div className="contentWrapper">
                  <Card className="formCard">
                    <CardContent className="cardContent">
                      <Typography variant="h5" component="h2" gutterBottom className="formTitle">
                        {title}
                      </Typography>
                      <form onSubmit={handleSubmit} className="responsiveForm">
                        <Grid container spacing={2}>
                          {userInputs.map((input) => (
                            <Grid item xs={12} sm={6} key={input.id} className="formGridItem">
                              <div className="formInput">
                                <label>{input.label}</label>
                                {input.fieldName === "role_id" ? (
                                  <Select
                                    options={filteredOptions}
                                    isMulti
                                    value={selectedRoles}
                                    onChange={handleRoleSelectChange}
                                    required
                                    className="selectInput"
                                    styles={{
                                      control: (base) => ({
                                        ...base,
                                        minHeight: '46px',
                                        borderColor: '#e2e8f0',
                                        '&:hover': {
                                          borderColor: '#cbd5e0'
                                        }
                                      }),
                                      valueContainer: (base) => ({
                                        ...base,
                                        padding: '2px 8px'
                                      }),
                                      input: (base) => ({
                                        ...base,
                                        margin: '0',
                                        padding: '0'
                                      }),
                                      indicatorsContainer: (base) => ({
                                        ...base,
                                        height: '44px'
                                      })
                                    }}
                                  />
                                ) : (
                                  <input
                                    type={input.type}
                                    placeholder={input.placeholder}
                                    name={input.fieldName}
                                    value={inputValues[input.fieldName] || ""}
                                    onChange={handleInputChange}
                                    required={input.fieldName !== "status"}
                                  />
                                )}
                              </div>
                            </Grid>
                          ))}
                        </Grid>
                        <Box sx={{ display: "flex", justifyContent: "center", gap: 3, mt: 4, pb: 2 }}>
                          <Button
                            variant="outlined"
                            color="secondary"
                            onClick={() => navigate("/user")}
                            sx={{ minWidth: '120px', height: '42px' }}
                          >
                            Cancel
                          </Button>
                          <Button
                            type="submit"
                            variant="contained"
                            color="primary"
                            sx={{ minWidth: '150px', height: '42px' }}
                          >
                            Create User
                          </Button>
                        </Box>
                      </form>
                    </CardContent>
                  </Card>
                </div>
              </div>
            </div>
          )}
          <ToastContainer position="top-right" autoClose={3000} />
        </>
      ) : (
        redirectToLogin()
      )}
    </ThemeProvider>
  );
};

export default UserNew;